import { Controller } from "stimulus"

export default class extends Controller {
    static targets = ["plan", "totalAmount", "submit", "withdrawalType"]

    lock(event) {
        event.preventDefault()
        const inputs = document.querySelectorAll('input[name="amount[]"]');
        let planObj = {}
        let rawTotalAmount = Number(this.totalAmountTarget.value)
        let customTotalAmount = 0
        let withdrawalType = this.withdrawalTypeTarget.value
        inputs.forEach(input => {
            let amount = Number(input.value)
            planObj[input.dataset.info] = amount
            customTotalAmount += amount
        });
        if(Math.abs(rawTotalAmount - customTotalAmount) < 1) {
            let plan = {"withdrawal_type": withdrawalType, "custom_total_amount": customTotalAmount, plan: planObj}
            this.planTarget.value = JSON.stringify(plan)
            this.submitTarget.disabled = false
        } else {
            alert("请核对金额分配!")
        }
    }
}